export default '/pricing/quiz-builder';
